import {  Component, OnInit,ChangeDetectorRef } from '@angular/core';

import { AuthService, User, UrlPipe, I18nModule } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { pairwise, switchMap } from 'rxjs/operators';
import { StartupService } from 'src/app/core/services/start-up.service';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { CustomProductsService } from '../../custom-landing/custom-products/custom-products.service';
import InventoryManagementService from '../../custom-landing/inventory-unpublished-batch/inventory-management.service';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { NgIf, AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
@Component({
    selector: 'app-custom-footer',
    templateUrl: './custom-footer.component.html',
    styleUrls: ['./custom-footer.component.scss'],
    imports: [NgIf, RouterLink, AsyncPipe, UrlPipe, I18nModule]
})
export class CustomFooterComponent implements OnInit {
  user$: Observable<User>;
  navlink = Array(5).fill(false);
  link: any;
  showErrorPage = false;
 showFooter = true;
 chinaInstance:any;
 b2bunits:any;
 displayShipdocsFlag: boolean;
 menuDisplay: any;
 companyValue:any = 0;
  constructor(private authservice: AuthService,
              private cd: ChangeDetectorRef,
              private userService: UserAccountFacade,
              private startUpService: StartupService,
              private customProductService: CustomProductsService,
              private inventoryManagementService: InventoryManagementService,
              private customProfileService: CustomProfileService,
             ) {

  }

  ngOnInit(): void {
   // this.getFooter();
    this.customProfileService.companyNameChange$.pipe(pairwise()).subscribe(([previous,current])=>{
      if(previous!=current){
        this.companyValue = current;
       // this.getFooterData();
      }
    },
    err=>{console.log(err)}
    )
    this.customProfileService.userIdChange$.pipe(pairwise()).subscribe(([previous,current])=>{
      if(previous!=current && current!=null && current!=undefined){
       // this.getFooterData();
      }
    })
    
    this.showErrorPage = this.startUpService.showErrorPage;
    this.user$ = this.authservice.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          return this.userService.get();
        } else {
          return of(undefined);
        }
      })
    );
    if (window.location.href.indexOf('login') > -1) {
      this.showFooter = false;
    }
    else {
      this.showFooter = true;
    }
  }

  homeLinkClick(value): any{
    this.customProductService.getHomeLinkActive(value);
  }
  scrollToTop(): any{
    try
    {
     window.scrollTo({top: 0, behavior: 'smooth' });
     } catch (e) {
      window.scrollTo(0, 0);
      }
  }
  getFooterData(){
    this.customProfileService.getBhpUnitList().subscribe( res => {
      if(res){
        this.b2bunits=res.myB2BUnits;
        this.menuDisplay=this.b2bunits.filter(data=>{return data.uid==localStorage.getItem('groupCompany')})[0]?.menuDisplay;
      // this.menuDisplay=this.companyValue==0?this.b2bunits[0].menuDisplay:this.b2bunits.filter(data=>{return data.uid==this.companyValue})[0]?.menuDisplay;
      this.displayShipdocsFlag=res && res.myB2BUnits && res.myB2BUnits.shipsDocdisplayFlag;
         this.cd.detectChanges();
      }
  
  },
  err=>{console.log(err)}
  );
  
}
getFooter(){
  this.customProductService.getMasterData().subscribe((resp: any)=>{
    this.chinaInstance=resp?.chinaInstanceCheck;
    this.cd.detectChanges(); 
});
}
}
